import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import Head from 'next/head';
export interface SectionWithBannerProps {
  data: any;
}
const SectionWithBanner: React.FC<SectionWithBannerProps> = ({ data }) => {
  const [isTabletSize] = useMediaQuery(tablet);
  const webpUrl = data?.banner_image?.url.replace(/\.[^/.]+$/, ".webp");
  const avifUrl = data?.banner_image?.url.replace(/\.[^/.]+$/, ".avif");
  return (
    <div className="relative w-full">
     <Head>
        <link
          rel="preload"
          href={webpUrl}
          as="image"
          imageSrcSet={`${webpUrl} 1200w,
          ${webpUrl}?w=200 200w, 
          ${webpUrl}?w=400 400w, 
          ${webpUrl}?w=800 800w, 
          ${webpUrl}?w=1024 1024w`}
        />
      </Head>
      <>
        {data?.banner_desktop_image?.url || data?.banner_image?.url ? (
          <div className="relative height23-rem height32-rem-lg height40-rem-3xl">
            <Image
              src={
                isTabletSize
                  ? data?.banner_desktop_image?.url || data?.banner_image?.url
                  : data?.banner_desktop_image?.url || data?.banner_image?.url
              }
              loading="eager"
              alt={data?.banner_desktop_image?.description}
              fill
              style={{ objectFit: 'cover', objectPosition: '85% 100%'}}
              className="brightness-50"
              height={500}
              width={500}
            />
          </div>
        ) : (
          <div className=""></div>
        )}
        <div
          className={`absolute left-15-per top-33-per max-w-675 translate-negative-y-50 transform padding-x-24 padding-x-0-lg ${
            data?.content_alignment === 'Center' ? 'text-center' : 'text-left'
          }`}
        >
          <Typography
            as="h1"
            className="padding-t-128 fontSize32-sm font-semibold lineHeight48 text-white drop-shadow-sm margin-t-120-lg w-32-lg fontSize36-xl fontSize48-2xl"
          >
            {data?.heading}
          </Typography>
          <Markdown
            markdown={data?.description}
            className="margin-y-24 whitespace-pre-line fontSize16-sm font-weight-normal lineHeight32 text-white w-32-lg fontSize14-xl fontSize20-2xl"
          />
          {data.ctas?.length > 0 &&
            data.ctas.map((ctaButton: any, index: number) => (
              <Link key={index} link={ctaButton?.button?.href}>
                <Button className="section-w-banner-cta border-1 rounded-0 border bg-white padding-x-32 padding-y-18 shadow-sm">
                  <Typography as="span" className=" fontSize16-sm font-medium lineHeight6 cta-text">
                    {ctaButton?.button?.title}
                  </Typography>
                </Button>
              </Link>
            ))}
        </div>
      </>
    </div>
  );
};
export default SectionWithBanner;